<template>
  <div class="home-box">
    <div class="home-top">
      <div class="home-top-bg">
        <div class="home-top-user">
          您好，{{userinfo.companyshortname }}！
        </div>

      </div>

    </div>

    <div class="home-top-box" style="position: relative;">

      <div class="home-top-des" v-if="userinfo.roletype != 2">
        <div class="home-top-des-left" @click="goView2">
          <img src="@/assets/images/daiban@3x.png" class="logo">
          <div class="logo-right">
            <div style="color: #1A1A1A;font-size:.28rem;margin-bottom:.04rem">待办合计</div>
            <div style="font-size: .48rem;display: flex;align-items: center;color: #505050;">{{db_totalnum}} <span class="timeout" v-if="overtimenum > 0"> 超时{{overtimenum}} </span> </div>
          </div>
        </div>
        <div class="hr"></div>
        <div class="home-top-des-right" @click="goView('/record?iftoday=1')">
          <img src="@/assets/images/caiji@3x.png" class="logo">
          <div class="logo-right">
            <div style="color: #1A1A1A;font-size:.28rem;margin-bottom:.04rem">今日采集</div>
            <div style="font-size: .48rem;color: #505050;">{{totalnum}}</div>
          </div>
        </div>
      </div>

      <div class="mode" v-if="userinfo.roletype != 9">
        <div class="mode-title">南京1号窗口业务采集</div>
        <div class="mode-content one">
          <div class="mode-item one" @click="goView('/newinsurance')">
            <div class="item-title" style="color: #A76826;">新车业务</div>
            <div class="item-btn one">立即录入</div>
          </div>
          <div class="mode-item two" @click="goView('/field?proposaltype=2')">
            <div class="item-title" style="color: #567191">
              <!-- 联保体外续保 -->
              非新车业务
            </div>
            <div class="item-btn two">立即录入</div>
          </div>
          <!-- <div class="mode-item three" @click="goView('/field?proposaltype=3')">
            <div class="item-title" style="color: #B56362;">外地回流业务</div>
            <div class="item-btn three">立即录入</div>
          </div> -->
          <div class="mode-item three" @click="goGrouporder">
            <div class="item-title" style="color: #B56362;">企业团单</div>
            <div class="item-btn three">去处理</div>
          </div>
          <div class="mode-item four"    @click="goView('/activeprotect')">
            <div class="item-title" style="color: #6C6CAB;">主动承保业务</div>
            <div class="item-btn four">立即录入</div>
          </div>

          <!-- <div class="mode-item four"  style="width:94.5%" @click="goView('/insuerdataMaintenance')">
            <div class="item-title" style="color: #6C6CAB;">中保信承保数据录入</div>
            <div class="item-btn four">立即录入</div>
          </div> -->

        </div>
      </div>

      <!-- <div class="mode " v-if="userinfo.roletype != 9">
        <div class="mode-title">联保体上年存量业务采集</div>
        <div class="mode-content lastyer">
          <div class="mode-item" @click="goView('/field?proposaltype=5')">
            <div class="item-title">联保体上年存量业务采集</div>
            <div class="item-btn">立即录入</div>
          </div>
        </div>
      </div> -->

      <div class="mode ">
        <div class="mode-title">查询</div>
        <div class="mode-content search">
          <div class="mode-item" @click="goView('/record')">
            <img src="@/assets/images/caijijilu@3x.png" alt="">
            <div class="item-btn">采集记录</div>
          </div>
          <div class="mode-item" v-if="userinfo.roletype == 1 || userinfo.roletype == 3 " @click="goView('/responsiblelist?recordstatus=2')">
            <img src="@/assets/images/banjiejilu@3x.png" alt="">
            <div class="item-btn">办结记录</div>
          </div>
          <div class="mode-item" @click="goView('/deviation')">
            <img src="@/assets/images/pianchalv@3x.png" alt="">
            <div class="item-btn">偏差率</div>
          </div>
        </div>
      </div>

      <div class="mode " v-if="userinfo.roletype != 2">
        <div class="mode-title" v-if="userinfo.roletype != 9">我司采集的他司处理中合计</div>
        <div class="mode-title" v-if="userinfo.roletype != 1 && userinfo.roletype != 3">待办统计</div>
        <div class="mode-content sum">
          <div class="mode-item" v-for="item in CompanyList" :key="item.companycode" @click="goView('/record?companycode='+item.companycode+'&recordstatus=1')">
            <div class="item-title">{{item.companyname}}</div>
            <div class="item-sum" :class="item.overtimenum > 0 ? 'red':''">{{item.totalnum}}</div>
            <div class="item-out" v-if="item.overtimenum > 0">超时{{item.overtimenum}}</div>
          </div>
        </div>
      </div>

      <div class="user-out" @click="userOut">
        退出当前帐号
      </div>

    </div>

  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router'
import request,{FrURL} from '@/utils/request'
import { showToast, showLoadingToast, showDialog , showConfirmDialog } from 'vant'

export default {
  setup () {
    let router = useRouter()
    let userinfo = JSON.parse(localStorage.getItem('yc_userinfo'))
    const goView = (path) => {
      router.push(path)
    }
    const userOut = () => {
      localStorage.removeItem('tz_token')
      localStorage.removeItem('yc_userinfo')
      router.push('/login')
    }

    const goView2 = () => {
      if (userinfo.roletype == 1 || userinfo.roletype == 3 ) {
        router.push('/responsiblelist?recordstatus=1')

      }
      if (userinfo.roletype == 9) {
        router.push('/record?recordstatus=1')
      }
    }

    // 待办合计 
    let overtimenum = ref('')
    let db_totalnum = ref('0')
    const getCountUnHandleForChargePerson = async () => {
      let res = {}
      // 管理-
      if (userinfo.roletype == 9) {
        res = await request({ url: '/home/countUnHandleForManage' })
      }
      // 负责-
      if (userinfo.roletype == 1  || userinfo.roletype == 3 ) {
        res = await request({ url: '/home/countUnHandleForChargePerson' })
      }


      if (res.errorcode == 0) {
        overtimenum.value = res.data.overtimenum
        db_totalnum.value = res.data.totalnum
      }
    }

    // 今日采集 
    let totalnum = ref('0')
    const getCountTodayCollectForChargePerson = async () => {
      let res = {}
      // 管理-
      if (userinfo.roletype == 9) {
        res = await request({ url: '/home/countTodayCollectForManage' })
      }
      // 负责-
      if (userinfo.roletype == 1 || userinfo.roletype == 3 ) {
        res = await request({ url: '/home/countTodayCollectForChargePerson' })
      }
      if (res.errorcode == 0) {
        totalnum.value = res.data.totalnum
      }
    }

    // 我司采集的他司处理中合计
    let CompanyList = ref([])
    const getCountMyCompanyCollectForChargePerson = async () => {
      let res = {}
      // 管理
      if (userinfo.roletype == 9) {
        res = await request({ url: '/home/countUnHandleCollectForManage' })
      }
      // 负责- 
      if (userinfo.roletype == 1 || userinfo.roletype == 3) {
        res = await request({ url: '/home/countMyCompanyCollectForChargePerson' })
      }
      if (res.errorcode == 0) {
        CompanyList.value = res.data
      }
    }

    onMounted(() => {
      document.title = '南京1号窗口'
      getCountUnHandleForChargePerson()
      getCountTodayCollectForChargePerson()
      getCountMyCompanyCollectForChargePerson()
    })


    function IsPC () {
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone",
        "SymbianOS", "Windows Phone",
        "iPad", "iPod"];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    }

     // 去电脑端
     const goGrouporder = () => {
     let path = FrURL + '#/frlogin?token='

      let str = window.location.origin + path +  localStorage.getItem('tz_token')
      if (IsPC()) {
        window.open(str)
      } else {
        copyContent(str)
      }
    }

    const copyContent = (text) => {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        // 尝试执行复制操作
        const success = document.execCommand('copy');
        if (success) {
          showToast('地址已复制,请使用电脑操作')
        } else {
          // createMessage.success('复制失败');
        }
      } catch (error) {
        // createMessage.success('复制失败');
      }
      document.body.removeChild(textarea);
    }

    return {
      userOut, goView, userinfo, goView2,
      CompanyList, totalnum, overtimenum, db_totalnum,goGrouporder
    }
  }
}
</script>

<style lang="less" scoped>
@import url("@/styles/home.less");
</style>